/**
 * Created by dv on 9/7/2017.
 */
import {
  DeleteCollectionMetadataForWebClientQuery,
  DeleteCollectionMetadataMessage,
  ValueList
} from "../../../autogenerated/ZoomBridge";

import HashMap from "../../../protocol/HashMap";
import HashSet from "../../../protocol/HashSet";

export default class DeleteCollectionMetadata {
  /**
   *
   * Creates a new object of the class to set the collection metadata
   * @param collectionId is the collection id for which the metadata is to be saved.
   */
  constructor(collectionId) {
    this._collectionId = collectionId;
    this._collectionMetadata = new HashMap();
  }

  /**
   * Sets the metadata key,value to the collection metadata map.
   * @param key is the metadata property name
   * @param value is the metadata value to be set.
   * @return {DeleteCollectionMetadata}
   */
  setMetadata(key, value) {
    if (!this._collectionMetadata || !this._collectionMetadata.containsKey(key)) {
      let valueList = new ValueList();
      valueList.setValues([]);
      this._collectionMetadata.put(key, valueList);
    }
    /**
     * @type {ValueList}
     */
    let valueList = this._collectionMetadata.get(key);
    valueList.getValues().push(value);
    return this;
  }

  /**
   *  Call this method, when user wants to delete all the metadata values of a specific metadataKey
   * @param keyToDelete
   */
  setDeleteAllMdKeys(keyToDelete) {
    this._deleteAll = true;
    if (!this._mdPropNamesToDelete) {
      this._mdPropNamesToDelete = new HashSet();
    }
    this._mdPropNamesToDelete.add(keyToDelete);
    return this;
  }

  run() {
    const message = new DeleteCollectionMetadataMessage();
    message.setCollectionId(this._collectionId);
    message.setCollectionMetadata(this._collectionMetadata);
    message.setDeleteAll(this._deleteAll);
    message.setMdPropName(this._mdPropNamesToDelete);
    const query = new DeleteCollectionMetadataForWebClientQuery();
    query.message = message;
    return query.run();
  }
}

